'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-04-18
 */

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-material/dist/vue-material.css'
import 'vue-material/dist/theme/default.css'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-balham.css'
import 'Common/css/main.less'
import 'Css/main.less'
import 'vue-tasty-burgers/dist/vue-tasty-burgers.css'
import VueKonva from 'vue-konva'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import vueResource from 'vue-resource'
import vueMaterial from 'vue-material'
import BootstrapVue from 'bootstrap-vue'
import i18n from 'Locale/lang'
import App from './AppComponent'
import appRouter from './router'
import VueGtag from 'vue-gtag'
import store from 'CommonApp/store'
import commonApp from 'CommonApp'
import appComponents from 'CommonApp/components'
import services from 'CommonApp/services'
import e24AppServices from 'CommonApp/e24-services'
import commonServices from 'Common/services'
import commonComponents from 'Common/components'
import {EventBus} from 'CommonApp/event-bus'
import Notifications from 'vue-notification'

import BackToTop from 'vue-backtotop'
import * as TastyBurgerButton from 'vue-tasty-burgers'
import progressBar from 'CommonApp/components/progressbar'

Vue.use(progressBar)
Vue.use(Notifications)
Vue.use(Router)
Vue.use(vueMaterial)
Vue.use(BootstrapVue)
Vue.use(vueResource)
Vue.use(services)
Vue.use(e24AppServices)
Vue.use(commonServices)
Vue.use(appComponents)
Vue.use(commonComponents)
Vue.use(commonApp)
Vue.use(VueKonva)

Vue.use(VueGtag, {
	config: { id: 'UA-98105267-2' },
	appName: 'Easytitle24 app',
	pageTrackerScreenviewEnabled: true
}, appRouter)

// Used in nav-bar common component
// TODO: This dependencies should be in easytitle24-common package
Vue.use(BackToTop)
Vue.use(TastyBurgerButton, { prefix: 'abc' })

Vue.config.productionTip = false
Vue.config.devtools = true

export const app = new Vue({
	el: '#app',
	store,
	i18n,
	router: appRouter,
	components: { App },
	template: '<App/>',
	beforeCreate () {
		// On page reload, check to see whether the user logged in previously
		Vue.e24.security.requestCurrentUser()
	},
	mounted () {
		EventBus.$on('jsonrpc', data => {
			if (data === 'INVALID_TOKEN') {
				// There was a json rpc post and the server reject the token we send ( for whatever reason).
				this.$router.push({name: 'connect', params: { goodbye: 'FORCED_LOGOUT', redirect: '', error: '' }})
				Vue.e24.security.clearLoginData()
			}
		})
	}
})

window.vue = app



// WEBPACK FOOTER //
// ./src/app/app.js